// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"237bb3dd","977":"fc950ab1"}[chunkId] + ".chunk.js";
};